import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getStorefrontPreviewToken = unaryRpc({
  name: "getStorefrontPreviewToken" as const,
  input: z.object({}),
  output: z.object({ token: z.string().min(1) }),
});
